<template>
    <div class="voltage-rise-validation" :class="{'is-active' : isActive, 'is-valid' : isValid}">
        <figure class="voltage-rise-validation__tick">
            <svg class="icon">
                <use xlink:href="#tick" />
            </svg>
        </figure>
        <svg class="voltage-rise-validation__arrow icon">
            <use xlink:href="#arrow-right" />
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        isValid: {
            type: Boolean,
            default: false,
        },
    }
};
</script>
